<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo" />
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">Diretores</p>
                <b-button @click="showFiltersBar" class="lupabusca">
                  <i class="fas fa-search dp-none"></i>
                </b-button>
                <b-button @click="hideFiltersBar" class="lupabusca closeLupa">
                  <i class="fas fa-times dp-none"></i>
                </b-button>

                <div class>
                  <div class id="tabela-diretors">
                    <b-button
                      class="is-white"
                      tag="router-link"
                      to="/admin/diretor/create"
                      type="is-link"
                    >ADICIONAR NOVO DIRETOR</b-button>

                    <b-table
                      :data="isEmpty ? [] : diretors"
                      :paginated="true"
                      :per-page="10"
                      :hoverable="true"
                    >
                      <template slot-scope="props">
                        <!-- colunas-->

                        <b-table-column
                          field="name"
                          label="Nome Completo"
                          searchable
                        >{{ props.row.name +" "+ props.row.sobrenome }}</b-table-column>

                        <b-table-column
                          field="email"
                          label="E-mail"
                          searchable
                        >{{ props.row.email }}</b-table-column>

                        <b-table-column field="cpf" label="CPF" searchable>{{ props.row.cpf }}</b-table-column>

                        <b-table-column field="escola" label="Escola" searchable>{{ props.row.nomeEscola }}</b-table-column>

                        <b-table-column field="actions" class="actionsHover" centered>
                          <!-- detalhes -->
                          <b-tooltip label="Detalhes" position="is-top" type="is-dark">
                            <button
                              class="button is-primary is-round"
                              id="info"
                              @click="info(props.row.id), isCardModalActive = true"
                            >
                              <b-icon icon="eye"></b-icon>
                            </button>
                          </b-tooltip>

                          <!-- editar -->
                          <b-tooltip label="Editar diretor" position="is-top" type="is-dark">
                            <router-link
                              :to="{ name: 'admin/diretor/update', params: { uuid: props.row.id }}"
                            >
                              <button class="button is-primary is-round" id="edit">
                                <b-icon icon="pencil"></b-icon>
                              </button>
                            </router-link>
                          </b-tooltip>

                          <!-- deletar -->
                          <b-tooltip label="Deletar diretor" position="is-top" type="is-dark">
                            <button
                              class="button is-primary is-round"
                              id="delete"
                              @click="deletar(props.row.id)"
                            >
                              <b-icon icon="delete-outline"></b-icon>
                            </button>
                          </b-tooltip>
                        </b-table-column>
                      </template>
                      <template slot="empty">
                        <Empty :messageEmpty="'Nada aqui.'" />
                      </template>
                    </b-table>
                  </div>
                </div>

                <b-modal :active.sync="isCardModalActive" style="width=729; height=425;">
                  <DiretorBase :usuario="diretor" />
                </b-modal>
              </div>
              <internfooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DiretorService from "@/services/DiretorService";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
import DiretorBase from "@/components/Perfil/DiretorBase";
import Empty from "@/components/Tables/Empty";

export default {
  data() {
    return {
      diretors: [],
      diretor: [],
      loading: true,
      isEmpty: false,
      isImageModalActive: false,
      isCardModalActive: false
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    DiretorBase: DiretorBase,
    Empty: Empty
  },
  created() {
    this.loading = true;
    DiretorService.Index().then(result => {
      this.diretors = result.data;
      this.loading = false;
    });
  },
  methods: {
    deletar(cuuid) {
      if (confirm("você realmente deseja excluir esse diretor?")) {
        DiretorService.Delete(cuuid)
          .then(() => {
            this.$buefy.toast.open({
              duration: 5000,
              message: "deleção realizado com sucesso!",
              position: "is-top-right",
              type: "is-success"
            });
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    info(id) {
      DiretorService.Info(id).then(result => {
        this.diretor = result.data;
      });
    }
  }
};
</script>
<style scoped>
.modal.is-active >>> .animation-content {
  max-width: none !important;
  width: 80%;
}
</style>